import { createValidator, maxLength, range, required } from 'util/validation'

import { validateDataMedicaoAnterior } from '../validator-medicaoAnterior'
import { MedicaoAnteriorAntropometriaFormModel } from './model-medicaoAnteriorAntropometria'

export const medicaoAnteriorAntropometriaValidator = (dataAtendimento: Instant, dataNascimentoCidadao: LocalDate) =>
  createValidator<MedicaoAnteriorAntropometriaFormModel>(
    {
      data: [required],
      peso: [maxLength(7), range(0.5, 500)],
      altura: [maxLength(5), range(20, 250)],
      perimetroCefalico: [maxLength(6), range(10, 200)],
    },
    (values, errors) => {
      if (values?.data && !values?.altura && !values?.perimetroCefalico && !values?.peso)
        errors.medicoes = 'Pelo menos uma das medições deve ser preenchida.'

      errors.data = validateDataMedicaoAnterior(values?.data, dataAtendimento, dataNascimentoCidadao) || errors.data

      return errors
    }
  )
